import React from "react";
import "../styles/CasosExito.scss";

export const CasosExito = () => {
  return (
    <div className="containerCasosExito d-flex justify-content-start align-items-center flex-column mt-3">
    <div className="d-flex justify-content-center align-items-center flex-column titleCasosExito text-center">
      <br/><span className="titleCasos mt-4">
        Cientos de clientes nos recomiendan
      </span>
      <span className="subtitleCasos fs-6">
      Descubre cómo nuestros servicios digitales han ayudado a empresas a potenciar su presencia en línea, optimizar procesos y mejorar su atención al cliente. Brindamos soluciones personalizadas que impulsan el crecimiento y la eficiencia de cada negocio. 
      </span>
    </div>
    <div className="resenasContainerManin mt-5 mb-5">
        <div className="resena" id="resena1">
            <span className="titleResena mt-3">Carlos Martínez</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
              Gracias al equipo de expertos en campañas de tráfico digital, mi negocio experimentó un cambio radical. Antes de trabajar con ellos, mi página web recibía pocas visitas, y las conversiones eran mínimas. Implementaron una campaña dirigida específicamente a los tomadores de decisiones en pequeñas empresas, y el impacto fue inmediato.
              </span>
            </div>
        </div>
        <div className="resena" id="resena2">
            <span className="titleResena mt-3">Sofía Rodríguez</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
              Siempre había oído que los videos son una herramienta poderosa para promocionar productos, pero nunca imaginé que tendría un impacto tan grande. Gracias a la creación del video especializado, mostrando la calidad y beneficios de nuestros productos naturales, logramos conectar de manera mucho más personal con nuestros clientes.
              </span>
            </div>
        </div>
        <div className="resena" id="resena3">
            <span className="titleResena mt-3">Ricardo Gómez</span>
            <div className="containerStars">
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
               <span><i className="fa-solid fa-star iconoEstilo"></i></span>
            </div><br/>
            <div className="containerDialogImg">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
            </div>
            <div className="containerOpinion mt-3">
              <span className="textOpinion">
              El chatbot que implementaron para mi tienda online ha sido una de las mejores inversiones. Antes de tenerlo, recibíamos una gran cantidad de preguntas repetitivas que nuestro equipo no podía atender de inmediato. Ahora, el chatbot responde instantáneamente a consultas sobre productos, disponibilidad y precios, lo que ha reducido drásticamente los tiempos de espera.
              </span>
            </div>
        </div>
    </div>
    <div className="d-flex justify-content-center align-items-center flex-column titleCasosExito text-center fs-5 mb-4">
      <span className="subtitleCasos">
      🚀 Ellos ya transformaron su negocio con nuestras soluciones digitales. 🚀<br/><br/><b>¡Tú también puedes hacerlo!</b> 
      </span>
    </div>
  </div>
  
  );
};

export default CasosExito;
